import React from 'react';
import Fragment from 'react-dot-fragment';
import OneVisualLayout from "../../layouts/one-visual";

import Image from '../../../../containers/assets/pf4.png';

const CareerPathwayStep1 = () => (
  <OneVisualLayout
    section="CAREER PATHWAY"
    title="Product &amp; Marketing"
    paragraph1={(
      <Fragment>
        In the real world, capturing market share is essential for survival.
        However, it can be challenging to find, collect, make sense, and
        make use of customer data. It's why the marketing and product management
        disciplines play a critical role in an organization.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default CareerPathwayStep1;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/career-pathway/step1.js